const mainNav = document.querySelector('.js-main-nav');
const inertElements = [
  ...document.querySelectorAll(
    '.js-skipnav, .js-mobile-nav, .js-find-dealer, .js-search-overlay, .js-country-selector, .js-main, .js-footer',
  ),
  mainNav,
];

export function mediaQueryDesktop() {
  return window.matchMedia('(min-width: 61.25em)');
}

export function addInert(elKeepingFocus, hasFocus) {
  inertElements.forEach((el) => el.setAttribute('inert', ''));
  if (elKeepingFocus.length) {
    elKeepingFocus.forEach((el) => el.removeAttribute('inert'));
  } else {
    elKeepingFocus.removeAttribute('inert');
    hasFocus && elKeepingFocus.focus();
  }
}

export function removeInert(elToFocusLater) {
  inertElements.forEach((el) => el.removeAttribute('inert'));

  // mainNav element is present on both mobile and desktop media query, although should be inert on mobile and lose inert when mobile menu opens
  if (!mediaQueryDesktop().matches && !mainNav.classList.contains('active')) {
    mainNav.setAttribute('inert', '');
  }
  elToFocusLater && elToFocusLater.focus();
}
